import { Row, Col, Flex, Grid, Button } from 'antd';
import { useMenu } from '@/contexts/menuContext';

import { useAppSelector } from '@/hooks/hooks';

import HeaderNavigation from './HeaderNavigation';
import { Container, ProfileDropdown } from '@/components/Elements';

import styles from './Header.module.scss';
import { useTheme } from '@/contexts/themeContext';
import AssistantButton from './AssistantButton';
import { Feedback } from './Feedback';
import { Menu } from 'lucide-react';
import TalkToBroker from './TalkToBroker';
const { useBreakpoint } = Grid;

const Header = () => {
  const { sidebarCollapseState, toggleSidebarState } = useTheme();

  const { activeTabs } = useMenu();
  const { userData } = useAppSelector((state) => state.auth);
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const handleMenuClick = () => {
    toggleSidebarState();
  };

  return (
    <>
      <header
        className={
          styles.headerContainer +
          ' ' +
          (isMobile
            ? ''
            : sidebarCollapseState
              ? styles.sidebarContainerCollapse
              : '')
        }
      >
        <Container fullWidth={true}>
          <Row gutter={30}>
            <Col
              xs={12}
              md={12}
              style={{
                padding: '0',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              {isMobile && (
                <Button
                  onClick={handleMenuClick}
                  type="text"
                  icon={
                    <Menu
                      strokeWidth={1.25}
                      style={{ fontSize: '22px', color: '#000' }}
                    />
                  }
                />
              )}
              <div className={styles.subMenuNavigation}>
                {activeTabs && <HeaderNavigation tabItems={activeTabs} />}
              </div>
            </Col>
            <Col xs={12} md={12} style={{ padding: '0' }}>
              <Flex
                justify="flex-end"
                style={{ height: '100%' }}
                align="center"
                gap={10}
              >
                {/* <AssistantButton /> */}
                <TalkToBroker />
                {/* <Feedback /> */}
                <div className={styles.headerMenuItem}>
                  <ProfileDropdown userDetail={userData} />
                </div>
              </Flex>
            </Col>
          </Row>
        </Container>
      </header>
    </>
  );
};

export default Header;
